import { getNumbersFromStr } from '@alfa-bank/site-form-helpers/text/get-numbers-from-str';
import type { TValidatorValue } from '@alfa-bank/site-form-helpers/src/validation/models';

export const PASSPORT_ERROR = 'Некорректные паспортные данные';

export const validatePassportNumber = (value: TValidatorValue) => {
    if (getNumbersFromStr(value)?.length !== 6) return PASSPORT_ERROR;

    return undefined;
};
